import React, { useRef, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { LearnMore } from '..'
import { Text } from '..';
import { FormattedMessage, useIntl } from 'react-intl'
import { useResize } from '../../hooks'
import { IoMdClose, VscClose } from 'react-icons/all';
import {
    Background, 
    Container, 
    ContainerFluid, 
    RowWrapper, 
    Col,
    StartVisitContainer,
    BtnClose,
    DivScroll,
    StartVisit,
    RowText
} from './index.styled'
import { ASSETS_FOLDER } from '../../assets';
import { store } from '../../effects/store';
import { setInfo } from '../../effects/actions';
const areas = require('./../../assets/mock-data/areas.json')
const processes = require('./../../assets/mock-data/processes.json')
const hotspotsInfos = require('./../../assets/mock-data/hotspots-infos.json')

const PopupComponent = ({ content, open, type = "popup", locale, showImage = true}) => {
    const history = useHistory();
    const [contentState, setContentState] = useState(null)
    const intl = useIntl()
    const isMobile = useResize().isMobile;
    const [ visitWidth, setVisitWidth ] = useState(0);
    const textRef = useRef(null);

    useEffect(() => {
      if(textRef?.current !== null) {
        const spanText = textRef.current.offsetWidth;
        if(spanText > 0 && spanText !== undefined)  setVisitWidth(spanText + 46);
      }
    }, [isMobile, visitWidth])

    useEffect(() => {
      if(type === "visit-area"){
        let data = areas.find(x => x.id === content)
        setContentState({...data, isVideo: false})
      }else if(type === "process-info"){
        let process = processes.find(x => x.id === content)
        setContentState({ ...process, title: process?.label, url: process?.image, isVideo: false })
      }else if(type === "info-message"){
        let hotspot = hotspotsInfos.find(x => x.id === content)
        setContentState({ ...hotspot, isVideo: false, showDescription: true })
      }else{
        setContentState(content)
      }
    }, [content, type])

    const renderVideo = () => {
      let lang = locale
      let isYoutube = false
    
      if(!(["pt", "en"].includes(locale))){
        lang = "en"
      }

      let url = contentState?.video[lang]
      
      if(url.search("youtube") !== -1){
        isYoutube = true
      }
      return (
        <Container className={`video ${isYoutube ? '' : 'not-youtube'}`}>
          {isYoutube ?
            (
              // eslint-disable-next-line jsx-a11y/iframe-has-title
              <iframe width="100%" height="100%" src={url} frameBorder="0"frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;" allowfullscreen></iframe>
            )
            :
            (
              <video width="100%" height="100%" controls="false">
                <source src={`${ASSETS_FOLDER}${url}`} type="video/mp4" />
                { intl.formatMessage({ id: "video.notice" }) }
              </video>
            )
          }
        </Container>
        
      )
    }

    const renderImage = () => {
      if(showImage){
        return (
          <Container>
            <img src={`${ASSETS_FOLDER}/${contentState?.url}`} alt="popup"/>
          </Container>
        )
      }
      return null
    }

    const onClose = () => {
      store.dispatch(setInfo(false,null))
    }

    return (
        <Background className={open ? 'open' : 'closed'}>
          {isMobile && <BtnClose onClick={() => onClose()} ><IoMdClose /> </BtnClose> }
          {(contentState !==  null) && (
            <ContainerFluid className="container-fluid">
              <RowWrapper className="row">
                <Col>
                  <div className="row content">
                    <div className="col-md-12">
                      {(contentState.isVideo !== undefined && contentState.isVideo) ? renderVideo() : renderImage()}
                    </div>
                  </div>
                  <RowText className="row">
                    <div className="col-md-12">
                      <div className="border-top" />
                      <DivScroll>
                        {contentState?.title && <Text className="title" textId={contentState.title} fontSize={"28px"} fontSizeMobile={"20px"} letterSpacing={'2px'} />}
                        {contentState?.subtitle && <Text className={`subtitle ${contentState?.audio ? 'voice-off' : ''}`} fontSize={`${contentState?.audio ? "16px" : "25px"}`} fontSizeMobile={"14px"} fontFamily="Amorim Sans Book" textId={contentState.subtitle} />}
                        {((contentState?.description && ["pt", "en"].includes(locale) === false) || contentState?.showDescription === true) && <Text className={`description ${contentState?.audio ? 'voice-off' : ''}`} fontSize={`${contentState?.audio ? "16px" : "25px"}`} fontSizeMobile={"14px"} fontFamily="Amorim Sans Book" textId={contentState?.description} />}
                        {(contentState?.descriptionProduct && contentState?.showDescription === true) && <Text className={`description ${contentState?.audio ? 'voice-off' : ''}`} fontSize={`${contentState?.audio ? "16px" : "25px"}`} fontSizeMobile={"14px"} fontFamily="Amorim Sans Book" textId={contentState?.descriptionProduct} />}
                      </DivScroll>
                    </div>
                  </RowText>
                </Col>
                {!isMobile && <BtnClose onClick={() => onClose()}><VscClose /></BtnClose> }
                {contentState?.audio && <LearnMore audio={contentState?.audio} locale={locale} />}
                
                <StartVisitContainer className="col-12">
                {contentState?.mainPano && (
                  <StartVisit widthStartVisit={visitWidth} onClick={() => {
                    history.push(contentState?.mainPano)
                    onClose()
                  }}>
                    <span ref={textRef}>
                      <FormattedMessage id="start-visit" />
                    </span>
                  </StartVisit>
                )}
                </StartVisitContainer>
              </RowWrapper>
            </ContainerFluid>
          )}
        </Background>
    )
};

  
export default React.memo(PopupComponent)